import { SWMS_METHODS_URL, SWMS_METHOD_ACTIVITY_URL, SWMS_METHOD_ORDER_URL, GET_METHOD_ITEMS_ADDITIONALS, METHOD_ITEMS_ADDITIONALS_URL } from "../../dataProvider/constant";
import { scopeApiInstance } from "../../dataProvider/axiosHelper";
import { Strings } from "../../dataProvider/localize";

export const getSwmsMethods = (params = {}, abortController) => () => {
    return scopeApiInstance.get(
        SWMS_METHODS_URL,
        {
            params: { ...params },
            ...abortController
        }
    )
        .then((res) => {
            if (res && res.data && res.data.data) {
                return Promise.resolve(res.data.data);
            } else {
                return Promise.reject(Strings.generic_error);
            }
        }).catch(error => {
            if (error) {
                return Promise.reject(
                    error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
                );
            } else {
                return Promise.reject(null);
            }
        })
}

export const getSwmsMethodDetails = (id, params = {}, abortController) => async (dispatch) => {
    return scopeApiInstance.get(
        `${SWMS_METHODS_URL}/${id}`,
        {
            params: { ...params },
            ...abortController
        }
    )
        .then((res) => {
            if (res && res.data && res.data.data) {
                return Promise.resolve(res.data.data);
            } else {
                return Promise.reject(Strings.generic_error);
            }
        })
        .catch(error => {
            if (error) {
                return Promise.reject(
                    error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
                );
            } else {
                return Promise.reject(null);
            }
        })

}

export const addEditSwmsMethod = (formData) => async () => {
    const method = formData.id ? scopeApiInstance.put : scopeApiInstance.post
    const url = formData.id ? `${SWMS_METHODS_URL}/${formData.id}` : SWMS_METHODS_URL
    return method(url, formData)
        .then(res => {
            if (res.data.status) {
                return Promise.resolve(res.data.message);
            }
        })
        .catch(error => {
            if (error) {
                return Promise.reject(
                    error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
                );
            } else {
                return Promise.reject(null);
            }
        })
}

export const changeMethodOrder = (formData) => async () => {
    return scopeApiInstance.patch(SWMS_METHOD_ORDER_URL, formData)
        .then(res => {
            if (res.data.status) {
                return Promise.resolve(res.data.message);
            }
        })
        .catch(error => {
            if (error) {
                return Promise.reject(
                    error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
                );
            } else {
                return Promise.reject(null);
            }
        })
}

export const getMethodItemsAdditionals = (abortController) => async (dispatch) => {
    return scopeApiInstance.get(METHOD_ITEMS_ADDITIONALS_URL)
        .then((res) => {
            if (res && res.data && res.data.data) {
                dispatch({
                    type: GET_METHOD_ITEMS_ADDITIONALS,
                    payload: res.data.data
                });
            }
            else {
                dispatch({
                    type: GET_METHOD_ITEMS_ADDITIONALS,
                    payload: []
                });
            }

        })
}

export const changeActivityOrder = (formData) => async () => {
    return scopeApiInstance.patch(SWMS_METHOD_ACTIVITY_URL, formData)
        .then(res => {
            if (res.data.status) {
                return Promise.resolve(res.data.message);
            }
        })
        .catch(error => {
            if (error) {
                return Promise.reject(
                    error && error.response && error.response.data && error.response.data.message ? error.response.data.message : Strings.network_error
                );
            } else {
                return Promise.reject(null);
            }
        })
}
